import * as _jquery2 from "jquery";
var _jquery = _jquery2;
try {
  if ("default" in _jquery2) _jquery = _jquery2.default;
} catch (e) {}
import * as _datatables2 from "datatables.net-bs5";
var _datatables = _datatables2;
try {
  if ("default" in _datatables2) _datatables = _datatables2.default;
} catch (e) {}
import * as _datatables4 from "datatables.net-rowgroup";
var _datatables3 = _datatables4;
try {
  if ("default" in _datatables4) _datatables3 = _datatables4.default;
} catch (e) {}
var exports = {};
/*! Bootstrap 5 styling wrapper for RowGroup
 * © SpryMedia Ltd - datatables.net/license
 */

(function (factory) {
  if (true) {
    // CommonJS
    var jq = _jquery;
    var cjsRequires = function (root, $) {
      if (!$.fn.dataTable) {
        _datatables(root, $);
      }
      if (!$.fn.dataTable.RowGroup) {
        _datatables3(root, $);
      }
    };
    if (typeof window === "undefined") {
      exports = function (root, $) {
        if (!root) {
          // CommonJS environments without a window global must pass a
          // root. This will give an error otherwise
          root = window;
        }
        if (!$) {
          $ = jq(root);
        }
        cjsRequires(root, $);
        return factory($, root, root.document);
      };
    } else {
      cjsRequires(window, jq);
      exports = factory(jq, window, window.document);
    }
  }
})(function ($, window, document) {
  'use strict';

  var DataTable = $.fn.dataTable;
  return DataTable;
});
export default exports;